import type { ReactNode } from 'react'

import { cn } from '../../lib/utils'

export type FeatureIconFrameProps = {
    children: ReactNode
    className?: string
}

/**
 * Shared icon container for hero feature rows and compact feature lists.
 */
export function FeatureIconFrame({ children, className }: FeatureIconFrameProps) {
    return (
        <span
            className={cn(
                'bg-illustration ring-foreground/10 before:bg-radial before:to-foreground/3 *:drop-shadow-black/6.5 relative inline-flex size-9 shrink-0 items-center justify-center rounded-lg border border-transparent shadow shadow-sm ring-1 *:drop-shadow before:absolute before:inset-0 before:rounded-lg',
                className,
            )}
        >
            {children}
        </span>
    )
}
